import React, {useLayoutEffect, useEffect, useState} from 'react';
import {Platform, TextStyle} from 'react-native';

import {useNavigation, useRoute} from '@react-navigation/native';

import {ConsultationPatientMedicalView, HeaderBackLeft} from './../../views';

import {PatientProfileReqResponse} from '../../server/types/patient-profile.types';
import {ConsultationStatusEnum} from '../../server/types/consultation.types';
import {colorPalette} from '../../../core/config/color.config';
import {width, height, totalSize} from 'react-native-dimension';

const ConsultationPatientMedicalScreen = () => {
  const route = useRoute();
  const navigation = useNavigation();

  const [patient, setPatient] = useState<PatientProfileReqResponse>();
  const [status, setStatus] = useState<ConsultationStatusEnum>(
    ConsultationStatusEnum.PENDING,
  );

  const onCancel = () => {
    goBack();
  };

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  };

  // useLayoutEffect(() => {
  //   if (Platform.OS !== 'web') {
  //     navigation.setOptions({
  //       title: 'Medical History',
  //       headerLeft: () => <HeaderBackLeft removeLabel />,
  //       // headerStyle: {
  //       //   borderBottomColor: 'transparent',
  //       //   elevation: 0,
  //       //   shadowOpacity: 0,
  //       // },
  //       headerShown: true,
  //             headerStyle: {
  //               elevation: 0,
  //               shadowOpacity: 0,
  //               backgroundColor: colorPalette.primary,
  //             },
  //             headerTintColor: colorPalette.blackLight,
  //             headerTitleStyle: {
  //               fontFamily: 'Quicksand-Medium',
  //               fontSize: totalSize(2),
  //               color: 'white',
  //             },
  //     });
  //   }
  // }, [navigation]);
  useLayoutEffect(() => {
    if (Platform.OS !== 'web') {
      navigation.setOptions({
        title: 'Medical History',
        headerTitleAlign: 'center',
        headerStyle: {
          borderBottomColor: 'transparent',
          elevation: 0,
          shadowOpacity: 0,
        },
        headerTintColor: colorPalette.blackLight,
        headerTitleStyle: {
          fontFamily: 'Quicksand-Bold',
          fontSize: totalSize(2),
          fontWeight: '600',
          alignSelf: 'center',
          // marginStart: -28,
        } as TextStyle,
        headerLeft: () => (
          <HeaderBackLeft removeLabel={true} iconName="left-gray" />
        ),
      });
    }
  }, [navigation]);

  useEffect(() => {
    const params: any = route.params;

    if (params && (params.patient || params.status)) {
      if (params.patient) {
        setPatient(params.patient);
      }
      if (params.status) {
        setStatus(params.status);
      }
    } else {
      goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route.params]);

  return (
    <>
      {!!patient && (
        <ConsultationPatientMedicalView
          patient={patient}
          status={status}
          onClose={onCancel}
        />
      )}
    </>
  );
};

export default ConsultationPatientMedicalScreen;
